<img src="{{ src }}" class="{{ cssClass }}" title="{{ title }}" alt="{{ alt }}" height="{{ height }}" width="{{ width }}" data-model-cid="{{ id }}" />

